module.exports = __webpack_public_path__ + "img/ruleset-list.ab30afd3.png";